import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import compose from 'recompose/compose';
import connect from "react-redux/es/connect/connect";
import Grid from "@material-ui/core/Grid/Grid";

// Icones

import {Typography} from "@material-ui/core";
import Button from "@material-ui/core/Button/Button";
import {getAutoclaves} from "../../actions/autoclaveActions";



const styles = theme => ({

    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dashboardCardSection: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1) * 8
    },
    dense: {
        marginTop: 19,
    },

});

class EmptyPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
    }





    render() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                <Typography></Typography>
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {

    }
}

export default connect(mapStateToProps, {  })(withStyles(styles, {withTheme: true})(EmptyPage))
